import React from 'react';
import { useTranslation } from 'react-i18next';

const YesIcon = () => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" className="shrink-0">
      <circle cx="8" cy="8" r="7" stroke="rgb(16,185,129)" strokeWidth="1.5" />
      <path d="M5 8l2 2 4-4" stroke="rgb(16,185,129)" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);

const NoIcon = () => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" className="shrink-0">
      <circle cx="8" cy="8" r="7" stroke="rgb(75,85,99)" strokeWidth="1.5" />
      <path d="M5.5 5.5l5 5M10.5 5.5l-5 5" stroke="rgb(75,85,99)" strokeWidth="1.5" strokeLinecap="round" />
    </svg>
);

const AudienceSection = () => {
  const { t } = useTranslation();
  const fits    = t('audience.fits',    { returnObjects: true });
  const notFits = t('audience.notFits', { returnObjects: true });

  return (
      <section className="py-24 bg-gray-900 border-t border-gray-800">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

          <div className="text-center mb-14">
          <span className="inline-block text-emerald-500 text-xs font-bold tracking-widest uppercase mb-3">
            {t('audience.label')}
          </span>
            <h2 className="text-3xl sm:text-4xl font-bold text-white mb-4">
              {t('audience.title')}
            </h2>
            <p className="text-gray-400 text-lg max-w-2xl mx-auto">
              {t('audience.subtitle')}
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-4xl mx-auto">

            {/* Подходит */}
            <div className="rounded-2xl bg-gray-800/50 border border-emerald-900/50 p-6 flex flex-col gap-5">
              <div className="flex items-center gap-2">
                <span className="w-2 h-2 rounded-full bg-emerald-500" />
                <h3 className="text-white font-semibold text-sm uppercase tracking-widest">
                  {t('audience.fitsTitle')}
                </h3>
              </div>
              <ul className="flex flex-col gap-3.5">
                {fits.map((item, i) => (
                    <li key={i} className="flex items-start gap-3">
                      <span className="mt-0.5"><YesIcon /></span>
                      <span className="text-gray-300 text-sm leading-snug">{item}</span>
                    </li>
                ))}
              </ul>
            </div>

            {/* Не подходит */}
            <div className="rounded-2xl bg-gray-800/30 border border-gray-700/50 p-6 flex flex-col gap-5">
              <div className="flex items-center gap-2">
                <span className="w-2 h-2 rounded-full bg-gray-600" />
                <h3 className="text-gray-400 font-semibold text-sm uppercase tracking-widest">
                  {t('audience.notFitsTitle')}
                </h3>
              </div>
              <ul className="flex flex-col gap-3.5">
                {notFits.map((item, i) => (
                    <li key={i} className="flex items-start gap-3">
                      <span className="mt-0.5"><NoIcon /></span>
                      <span className="text-gray-500 text-sm leading-snug">{item}</span>
                    </li>
                ))}
              </ul>
            </div>

          </div>
        </div>
      </section>
  );
};

export default AudienceSection;
